import { useEffect, useState } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { useStorage } from '../../utils/firebase';

const useResolutionPdfUrls = ({ open, ready, storagePaths = [] }) => {
  const storage = useStorage();
  const [pdfUrls, setPdfUrls] = useState([]);
  const [loadError, setLoadError] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);

  useEffect(() => {
    if (!open || !storagePaths.length || !ready) return;
    setLoadError(false);
    setPdfUrls([]);
    setLoadedCount(0);
    Promise.all(storagePaths.map(path => getDownloadURL(ref(storage, path))))
      .then(urls => setPdfUrls(urls))
      .catch(() => setLoadError(true));
  }, [open, ready, storagePaths, storage]);

  useEffect(() => {
    if (!open) {
      setPdfUrls([]);
      setLoadError(false);
      setLoadedCount(0);
    }
  }, [open]);

  const onIframeLoad = () => setLoadedCount(prev => prev + 1);

  return { pdfUrls, loadError, loadedCount, onIframeLoad };
};

export { useResolutionPdfUrls };
